/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const Chromium = [
  ["path", { d: "M10.88 21.94 15.46 14" }],
  ["path", { d: "M21.17 8H12" }],
  ["path", { d: "M3.95 6.06 8.54 14" }],
  ["circle", { cx: "12", cy: "12", r: "10" }],
  ["circle", { cx: "12", cy: "12", r: "4" }]
];

export { Chromium as default };
//# sourceMappingURL=chromium.js.map
